export const materialsSelector = (state) => state.materials.materials.items;
export const texturesSelector = (state) => state.materials.textures.items;
export const materialsCountsSelector = (state) => state.materials.counts;

export const selectSelectedSorting = (state) => state.materials.sorting;

